export default {
  step2: [
    {
      id:10,
      step: 2,
      stepJp: "リングのかたち",
      name: "ラウンド",
      property: "shape",
      val: "round",
      summary:"ラウンド（ベーシックな甲丸/ ミルグレインにおすすめ）",
    },
    // {
    //   id:11,
    //   step: 2,
    //   stepJp: "リングのかたち",
    //   name: "ボリュームラウンド",
    //   property: "shape",
    //   val: "volumeRound",
    //   summary:"ボリュームラウンド（丸みの強い厚めの甲丸）",
    // },
    {
      id:12,
      step: 2,
      stepJp: "リングのかたち",
      name: "フラット",
      property: "shape",
      val: "flat",
      summary:"フラット（角のくっきりした平打ち）",
    },
    {
      id:13,
      step: 2,
      stepJp: "リングのかたち",
      name: "ソフトフラット",
      property: "shape",
      val: "softFlat",
      summary:"ソフトフラット（角が落ちた平打ち）",
    },
    {
      id:14,
      step: 2,
      stepJp: "リングのかたち",
      name: "プレート",
      property: "shape",
      val: "plate",
      summary:"プレート（ゆるくラウンドした平たい形）",
    },
  ]
}
